import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, messageErreur } from "@/lib/api";

const Reglage = ({ ecran, role, vues, reglage, onMaj }) => {
  const compatibles = vues.filter((v) => v.ecrans.includes(ecran));
  const choisies = reglage?.vues || [];
  const enregistrer = (liste, defaut) => api.put(`/vues/reglages/${ecran}/${role}`, { vues: liste, defaut }).then(onMaj).catch((e) => toast.error(messageErreur(e)));
  if (!compatibles.length) return null;
  return (
    <div className="at-soft p-3" data-testid={`views-setting-${ecran}-${role}`}>
      {compatibles.map((v) => (
        <div key={v.code} className="flex items-center gap-2 min-h-[44px]">
          <label className="flex items-center gap-2 text-sm flex-1 min-w-0"><input type="checkbox" checked={choisies.includes(v.code)} data-testid={`views-setting-${ecran}-${role}-${v.code}`}
            onChange={(ev) => enregistrer(ev.target.checked ? [...choisies, v.code] : choisies.filter((c) => c !== v.code), reglage?.defaut)} />
            <span className="truncate">{v.lettre}. {v.nom}{v.statut === "pause" ? " (en pause)" : ""}</span></label>
          {choisies.includes(v.code) && (
            <label className="flex items-center gap-1.5 text-xs font-semibold shrink-0 min-h-[44px]"><input type="radio" name={`def-${ecran}-${role}`} checked={reglage?.defaut === v.code}
              onChange={() => enregistrer(choisies, v.code)} data-testid={`views-default-${ecran}-${role}-${v.code}`} />Par défaut</label>
          )}
        </div>
      ))}
    </div>
  );
};

export default function Vues() {
  const [data, setData] = useState(null);
  const [ecran, setEcran] = useState("accueil");
  const charger = useCallback(() => api.get("/vues").then((r) => setData(r.data)), []);
  useEffect(() => { charger(); }, [charger]);
  if (!data) return null;
  const basculer = (v) => api.post(`/vues/${v.code}/statut`, { statut: v.statut === "actif" ? "pause" : "actif" })
    .then(() => { toast.success(v.statut === "actif" ? "Vue mise en pause." : "Vue activée."); charger(); }).catch((e) => toast.error(messageErreur(e)));
  return (
    <div className="space-y-6">
      <section>
        <h2 className="text-base md:text-lg font-bold mb-3">Catalogue des vues</h2>
        <div className="space-y-2" data-testid="views-catalogue">
          {data.vues.map((v) => (
            <div key={v.code} className="at-card p-4 flex items-start gap-3" data-testid={`view-card-${v.code}`}>
              <span className="w-9 h-9 at-pill flex items-center justify-center font-bold shrink-0" style={{ background: "var(--surface-2)" }}>{v.lettre}</span>
              <div className="flex-1 min-w-0">
                <p className="font-bold">{v.nom}</p>
                <p className="text-sm at-muted">{v.description}</p>
                <p className="text-xs at-muted mt-1">Écrans : {v.ecrans.map((e) => data.ecrans[e]).join(", ")}</p>
              </div>
              <button type="button" onClick={() => basculer(v)} className="min-h-[44px] px-4 at-pill font-semibold text-sm shrink-0" data-testid={`view-status-${v.code}`}
                style={{ background: v.statut === "actif" ? "var(--accent)" : "var(--surface-2)", color: v.statut === "actif" ? "var(--accent-ink)" : "var(--ink)" }}>{v.statut === "actif" ? "Active" : "En pause"}</button>
            </div>
          ))}
        </div>
      </section>
      <section>
        <h2 className="text-base md:text-lg font-bold mb-3">Vues par écran et par profil</h2>
        <div className="flex gap-2 overflow-x-auto no-scrollbar mb-3">
          {Object.entries(data.ecrans).map(([c, l]) => (
            <button key={c} type="button" onClick={() => setEcran(c)} className="min-h-[44px] px-4 at-pill font-semibold whitespace-nowrap" data-testid={`views-screen-${c}`}
              style={{ background: ecran === c ? "var(--accent)" : "var(--surface)", color: ecran === c ? "var(--accent-ink)" : "var(--ink)" }}>{l}</button>
          ))}
        </div>
        <div className="grid md:grid-cols-2 gap-3">
          {Object.entries(data.roles).map(([r, l]) => (
            <div key={r}>
              <p className="font-bold text-sm mb-1.5">{l}</p>
              <Reglage ecran={ecran} role={r} vues={data.vues} reglage={data.reglages.find((x) => x.ecran === ecran && x.role === r)} onMaj={charger} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
